import {ChangeEvent, ReactElement, useState} from 'react'
import {FormControl, TextField, Button, MenuItem, InputLabel, Select} from '@material-ui/core'
import {Trans} from 'react-i18next'
import {
  payRetailersWithdrawalBanks,
  payRetailersBankAccountTypes,
  payRetailersDocumentTypes,
} from '@bdswiss/common-enums'

import messages from '../../../../../../../assets/messages'
import {PAY_RETAILERS_FIELD_NAMES, PAY_RETAILERS_DEFAULT_FIELD_VALUES} from '../../../constants'
import {useStyles} from './styles'

type PayRetailerFieldsProps = {
  payRetailersPaymentFields: Record<string, any> | null
  onPayRetailersSet: (fieldValues) => void
  onClose: () => void
}

const bankOptions = Object.values(payRetailersWithdrawalBanks.ng)
const bankAccountOptions = Object.values(payRetailersBankAccountTypes.ng)
const documentTypesOptions = Object.values(payRetailersDocumentTypes.ng)

function PayRetailerFields(props: PayRetailerFieldsProps): ReactElement {
  const classes = useStyles()
  const {payRetailersPaymentFields, onPayRetailersSet, onClose} = props
  const [formFieldsValues, setFormFieldsValues] = useState(
    payRetailersPaymentFields || PAY_RETAILERS_DEFAULT_FIELD_VALUES,
  )

  const isSubmitDisabled = (function () {
    return Object.values(formFieldsValues).some((value) => !value.toString().trim())
  })()

  const handleTextFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value, name} = event.target
    setFormFieldsValues((prevValues) => ({...prevValues, [name]: value}))
  }

  const handleSelectFieldChange = (
    event: ChangeEvent<{name?: string | undefined; value: unknown}>,
  ) => {
    const {value, name} = event.target
    if (!name || !value) return

    setFormFieldsValues((prevValues) => ({...prevValues, [name]: value}))
  }

  const handleSave = () => {
    onPayRetailersSet(formFieldsValues)
    onClose()
  }

  return (
    <>
      <FormControl fullWidth>
        <InputLabel>
          <Trans {...messages.bank} />
        </InputLabel>
        <Select
          name={PAY_RETAILERS_FIELD_NAMES.bankCode}
          value={formFieldsValues.bankCode}
          onChange={handleSelectFieldChange}
        >
          {bankOptions.map(({value, label}) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PAY_RETAILERS_FIELD_NAMES.document}
          value={formFieldsValues.document}
          label={<Trans {...messages.personalIdentificationNumber} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <InputLabel>
          <Trans {...messages.documentType} />
        </InputLabel>
        <Select
          name={PAY_RETAILERS_FIELD_NAMES.documentType}
          value={formFieldsValues.documentType}
          onChange={handleSelectFieldChange}
        >
          {documentTypesOptions.map(({value, label}) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <InputLabel>
          <Trans {...messages.accountType} />
        </InputLabel>
        <Select
          name={PAY_RETAILERS_FIELD_NAMES.bankAccountType}
          value={formFieldsValues.bankAccountType}
          onChange={handleSelectFieldChange}
        >
          {bankAccountOptions.map(({value, label}) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PAY_RETAILERS_FIELD_NAMES.bankAccountNumber}
          value={formFieldsValues.bankAccountNumber}
          label={<Trans {...messages.bankAccount} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PAY_RETAILERS_FIELD_NAMES.beneficiaryEmail}
          value={formFieldsValues.beneficiaryEmail}
          label={<Trans {...messages.email} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PAY_RETAILERS_FIELD_NAMES.beneficiaryFirstName}
          value={formFieldsValues.beneficiaryFirstName}
          label={<Trans {...messages.firstName} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PAY_RETAILERS_FIELD_NAMES.beneficiaryLastName}
          value={formFieldsValues.beneficiaryLastName}
          label={<Trans {...messages.lastName} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PAY_RETAILERS_FIELD_NAMES.beneficiaryPhone}
          value={formFieldsValues.beneficiaryPhone}
          label={<Trans {...messages.phoneNumber} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <Button
        disabled={isSubmitDisabled}
        variant="contained"
        color="primary"
        onClick={handleSave}
        className={classes.button}
      >
        <Trans {...messages.saveAndContinue} />
      </Button>
    </>
  )
}

export {PayRetailerFields}
